import type { Module } from 'vuex';
import { ICategory } from '../../entities/category-entity';
import {IMenuTreeItem} from "../../entities/menu-entity";
import {Category} from "sitisjs/dist/internal/sections/categories/models/Category";
import {IGetCategoryDetailedParams} from "../../../lib/store/modules/catalog-store";

export const namespace = 'promotions';

export const MutationType = {
	SET_PROMOTIONS: 'SET_PROMOTIONS',
	SET_PROMOTION: 'SET_PROMOTION',
	SET_CATEGORY_DETAILED: 'setCategoryDetailed',
};
export const actionType = {
	GET_PROMOTIONS: 'GET_PROMOTIONS',
	GET_CATEGORY_DETAILED: 'GET_CATEGORY_DETAILED',
};



export default function promotionsStore(): Module<any, any> {
	return {
		namespaced: true,
		state: () => ({
			promotion: null,
			promotions: [],
		}),
		actions: {
			async [actionType.GET_PROMOTIONS]({ commit }): Promise<any> {
				try {
					commit('appState/setLoading', { promotions: true }, { root: true });
					const res = await this.$api.promotion.getPromotions.execute({
						page: 1
					});
					const catalog = res.getValue();
					const promotions = catalog?.promotions || [];
					commit(MutationType.SET_PROMOTIONS, promotions);
					return promotions;
				} finally {
					commit('appState/setLoading', { promotions: false }, { root: true });
				}
			},
			async [actionType.GET_CATEGORY_DETAILED]({ commit, state, dispatch }, params: IGetCategoryDetailedParams): Promise<ICategory | undefined> {
				const {
					slug,
					extensions
				} = params;

				let filters = [];
				if ((extensions || []).length > 0) {
					filters.push(`expand=${extensions?.join(',')}`)
				}

				try {
					commit('appState/setLoading', { category: true }, { root: true });

					const filterString = Boolean(filters.length > 0) ? `?${filters.join("&")}` : "";
					const response = await this.$api.agent.transport.get(`/promotions/${ slug }${ filterString }`).then((res: any) => {
						return res.data
					}).catch(() => {
						return undefined
					})
					if (!response) {
						return undefined
					}

					const category = new Category(response);

					commit(MutationType.SET_CATEGORY_DETAILED, category || null);

					return category;
				} finally {
					// commit('appState/setLoading', { category: false }, { root: true });
				}
			},
		},
		mutations: {
			[MutationType.SET_PROMOTIONS]: (state, promotions: any[]) => {
				state.promotions = promotions;
			},
			[MutationType.SET_PROMOTION]: (state, promotion: any[]) => {
				state.promotion = promotion;
			},
			[MutationType.SET_CATEGORY_DETAILED]: (state, category: ICategory) => {
				state.promotion = category;
			},
		},
		getters: {
			promotion: ({ promotion }) => promotion,
			promotions: ({ promotions }): ICategory[] => promotions
		},
	};
}
